import { reportInvoiceRelationshipTypes } from './types';
import { newDate } from "helpers/dateTools";

const { GET_REPORT_INVOICE_RELATIONSHIP, SET_REPORT_INVOICE_RELATIONSHIP_FILTERS, RESTORE_INITIAL } = reportInvoiceRelationshipTypes;

const initialState = {
  ReportInvoiceRelationship: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportInvoiceRelationshipReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORT_INVOICE_RELATIONSHIP:
      return { ...state, ReportInvoiceRelationship: payload };
    case SET_REPORT_INVOICE_RELATIONSHIP_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case RESTORE_INITIAL:
      return initialState;
    default:
      return state;
  }
};
